module.exports = __webpack_public_path__ + "img/流体力学1_3_2.bfe9af0a.jpg";